import React, { PureComponent } from "react";

import { WindowEvent } from "./WindowEvent";

export interface IEscapeProps {
    onEsc: () => void;
}

export class Escape extends PureComponent<IEscapeProps> {
    public render() {
        return (
            <>
                <WindowEvent type="keypress" onEvent={this.onKeyDown} />
                <WindowEvent type="keydown" onEvent={this.onKeyDown} />
            </>
        );
    }

    private onKeyDown = (event: KeyboardEvent) => {
        if (event.key === "Escape") {
            this.props.onEsc();
        }
    };
}
